import { ImpNoticeComponent } from '../../../../dashboard/loggedin-content/imp-notice/imp-notice.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreIputWithValidationComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreAlertComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { ProfileConfirmModalComponent } from '../../../../dashboard/loggedin-content/profile/profile-confirm-modal/profile-confirm-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router, Params, RouterModule } from '@angular/router';
import {
  AlertService,
  FormBase,
  FormBaseControlService,
  GetGooglePlaceService,
  ValidateAddressService,
  GTagService,
  AcmicService,
  ModalOptions,
} from '@mapfre-design-library/src/public_api';
import { ChangeAddressService } from './../../../../../_services/change-address/change-address.service';
import { ProfileConfirmModalService } from '../../../../../_services/profile-settings/profile-confirm-modal.service';
import { ErrorRedirectionService } from '../../../../../_services/error-service/error-redirection.service';
import { AddressService } from '../../../../../_services/change-address/validate-address.service';
import { AbvToFulstatePipe } from '../../../../../_helpers/_pipes/abv-to-fulstate.pipe';
import { CustomerProfileService } from '../../../../../_services/customer-profile/customer-profile.service';
import { AgentNotificationService } from '../../../../../_services/agent/agent-notification.service';
import { CompanyTypeService } from '../../../../../_services/_iam/company-type.service';
import { take } from 'rxjs/operators';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, ProfileConfirmModalComponent, MapfreAlertComponent, MapfreButtonComponent, MapfreIputWithValidationComponent, MapfreModalComponent, ImpNoticeComponent],
  selector: 'app-change-address-form',
  templateUrl: './change-address.component.html',
  styleUrls: ['./change-address.component.scss'],
  providers: [FormBaseControlService, AbvToFulstatePipe],
})
export class ChangeAddressComponent implements OnInit, OnDestroy {
  @Input() policyData: any;
  @Input() inputs: FormBase<any>[] = [];
  @Input() policyStateCode: string;
  @Input() policies: any;
  addressType: string;
  state: string;
  changeAddressForm: FormGroup;
  loading = false;
  policyID: string;
  addressObject: any;
  addressInput: any;
  confirmModal: boolean;
  loader = false;
  enableSubmitBtn = true;
  email: string;
  showAlert: boolean;
  isPOBoxAddSelected: boolean;
  isMailingAddSelected: boolean;
  isLocationSame: boolean;
  hideCityStateField: boolean;
  hidePoBoxCityStateField: boolean;
  hideZipcodeField: boolean;
  cityState: string;
  poBoxCity: string;
  poBoxState: string;
  isZipcodeValid: boolean;
  isPoBoxZipcodeValid: boolean;
  hideMultipleCityStateField: boolean;
  hidePOMultipleCityStateField: boolean;
  multipleCityOptionsForMailing;
  multipleCityOptionsForPOBox;
  isAcmic = false;
  company: any;
  confirmationModal: ModalOptions;
  hideModal: boolean;
  hasAtleastOneLegacyPolicy: boolean;
  showNotification = true;
  currentAddressObject: Address;
  currentStreetAPT: string;
  currentStreetName: string;
  newStreetName: string;
  clickTrakcer = 0;
  isGWPolicy: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private changeAddressService: ChangeAddressService,
    private ipt: FormBaseControlService,
    public router: Router,
    private getGooglePlaceService: GetGooglePlaceService,
    private validateAddressService: ValidateAddressService,
    private profileConfirmModalService: ProfileConfirmModalService,
    private errorRedirectionService: ErrorRedirectionService,
    private addressService: AddressService,
    private abvToFulstatePipe: AbvToFulstatePipe,
    private gTagService: GTagService,
    private translate: TranslateService,
    private customerProfileService: CustomerProfileService,
    private acmicService: AcmicService,
    private agentNotification: AgentNotificationService,
    private companyTypeService: CompanyTypeService
  ) {
    this.isMailingAddSelected = true;
    this.isPOBoxAddSelected = false;
    this.hideCityStateField = true;
    this.isZipcodeValid = false;
    this.isPoBoxZipcodeValid = false;
    this.hideMultipleCityStateField = true;
    this.hidePOMultipleCityStateField = true;
    this.isLocationSame = true;
    this.multipleCityOptionsForMailing = ['city'];
    this.multipleCityOptionsForPOBox = ['city'];
    this.hidePoBoxCityStateField = true;
    this.hideZipcodeField = true;
    this.cityState = '';
    this.poBoxCity = '';
    this.poBoxState = '';
  }

  changeAddress(): void {
    // this.createAddressObject();
    if (this.addressType == 'residential') {
      this.createAddressObject();
      this.residental(this.policyID);
    } else if (this.addressType == 'mailing') {
      this.mailing(this.policyID);
    }
  }
  triggerObjectCretion() {
    this.clickTrakcer++;
    if (this.clickTrakcer === 1) {
      this.createAddressObject();
    }
  }

  createAddressObject() {
    if (this.policyID.length == 6) {
      if (this.changeAddressForm.controls.changeAddressAPT.value) {
        const APT =
          this.changeAddressForm.controls.changeAddressAPT.value != ''
            ? this.changeAddressForm.controls.changeAddressAPT.value.trim()
            : this.changeAddressForm.controls.changeAddressAPT.value;
        this.addressObject.streetName =
          (this.addressObject?.streetName?.includes('|')
            ? this.addressObject?.streetName?.split('|')[0]
            : this.addressObject?.streetName?.split('#')[0]) + ' #' + APT;
      } else {
        this.addressObject.streetName = this.addressObject.streetName.includes(
          '|'
        )
          ? this.addressObject.streetName.split('|')[0]
          : this.addressObject.streetName.split('#')[0];
      }

      this.updatePoBox();
    } else {
      this.createGWAddressObject();
    }
  }

  updatePoBox() {
    if (this.isPOBoxAddSelected) {
      const formControls = this.changeAddressForm.controls;
      this.addressObject.streetName = `PO box ${formControls.changeAddress_poBox.value}`;
      this.addressObject.city = this.poBoxCity;
      this.addressObject.state = this.poBoxState;
      this.addressObject.zipCode.code =
        formControls.changeAddress_PO_zipCode.value;

      this.agentNotification.setHeader(this.policyData);

      this.addressObject = {
        header: this.agentNotification.getHeader(),
        address: this.addressObject,
      };
    }
  }

  createGWAddressObject() {
    if (this.isPOBoxAddSelected) {
      this.updatePoBox();
    } else {
      if (this.changeAddressForm.controls.changeAddressAPT.value) {
        const APT =
          this.changeAddressForm.controls.changeAddressAPT.value != ''
            ? this.changeAddressForm.controls.changeAddressAPT.value.trim()
            : this.changeAddressForm.controls.changeAddressAPT.value;
        this.addressObject.streetName =
          (this.addressObject?.streetName?.includes('|')
            ? this.addressObject.streetName?.split('|')[0]
            : this.addressObject.streetName?.split('#')[0]) +
          ' #' +
          APT;
      } else {
        this.addressObject.streetName = this.addressObject?.streetName?.includes(
          '|'
        )
          ? this.addressObject.streetName?.split('|')[0]
          : this.addressObject.streetName?.split('#')[0];
      }

      this.agentNotification.setHeader(this.policyData);
      this.addressObject = {
        header: this.agentNotification.getHeader(),
        address: this.addressObject,
      };
      this.newStreetName = this.addressObject?.address?.streetName?.includes('|')
        ? this.addressObject.address.streetName?.split('|')[0]
        : this.addressObject.address.streetName?.split('#')[0];
    }
  }

  mailing(policyid) {
    this.loader = true;
    this.enableSubmitBtn = false;
    if (this.policyID.length == 6) {
      this.changeAddressService
        .updateMailingAddress(policyid, this.email, this.addressObject)
        .subscribe(
          () => {
            this.addressUpdateResponse(policyid);
          },
          (error) => {
            this.onMailingAddressUpdateError(error);
          }
        );
    } else {
      this.changeAddressService
        .updateMailingAddressV2(policyid, this.email, this.addressObject)
        .subscribe(
          () => {
            this.addressUpdateResponse(policyid);
          },
          (error) => {
            this.onMailingAddressUpdateError(error);
          }
        );
    }
  }

  onMailingAddressUpdateError(error) {
    this.gTagService.triggerFormLink(
      'changeAddressForm',
      'false',
      this.translate.instant('ADDRESS_UPDATE_ERROR')
    );
    this.loader = false;
    this.errorRedirectionService.errorHandler(
      error,
      'CHANGE_ADDRESS_ALERT_ERROR'
    );
  }

  residental(policyid) {
    this.loader = true;
    const validateAddress = this.validateAddressService.validateAddress(
      this.addressInput,
      this.getGooglePlaceService,
      true,
      this.policyStateCode
    );
    if (validateAddress) {
      this.enableSubmitBtn = false;
      if (this.policyID.length == 6) {
        this.changeAddressService
          .updateResidentialAddress(
            policyid,
            this.email,
            this.changeAddressForm.value,
            this.addressObject
          )
          .subscribe(
            () => {
              this.addressUpdateResponse(policyid);
            },
            (error) => {
              this.onMailingAddressUpdateError(error);
            }
          );
      } else {
        this.changeAddressService
          .updateResidentialAddressV2(
            policyid,
            this.email,
            this.changeAddressForm.value,
            this.addressObject
          )
          .subscribe(
            () => {
              this.addressUpdateResponse(policyid);
            },
            (error) => {
              this.onMailingAddressUpdateError(error);
            }
          );
      }
    } else {
      this.gTagService.triggerFormLink(
        'changeAddressForm',
        'false',
        this.translate.instant('INVALID_ADDRESS')
      );
      this.loader = false;
      this.showAlert = true;
      this.company = this.companyTypeService.getCompany(this.policyID);
      if (this.state == 'ID' && this.addressObject.state != 'ID') {
        this.alertService.error('PLEASE_ENTER_VALID_ADDRESS_ID');
      } else if (this.state == 'WA' && this.addressObject.state != 'WA') {
        this.alertService.error('PLEASE_ENTER_VALID_ADDRESS_WA');
      } else if (this.state == 'MA' && this.addressObject.state != 'MA') {
        this.alertService.error("Please Enter Valid Address");
      }
    }
  }

  addressUpdateResponse(policyid) {
    this.gTagService.triggerFormLink('changeAddressForm', 'true', '');
    this.loader = false;
    if (policyid.length > 6) {
      this.addressObject = this.addressObject.address;
      this.addressObject.policyid = policyid;
      this.addressObject.state = this.abvToFulstatePipe.transform(
        this.addressObject.state
      );
      this.addressService.setAddress(this.addressObject);
    }
    const livoMsg = ' address successfully submitted!';
    const as400Msg =
      ' address request received! Please allow us 5 business days to process your request.';
    if (policyid.length > 6) {
      if (
        this.addressType == 'residential' &&
        this.changeAddressForm.value.isMailingAddress
      ) {
        this.changeAddressService.setIsResidentialAddressUpdated(true);
        this.changeAddressService.setIsMailingAddressUpdated(true);
        this.alertService.success('Residential and mailing' + livoMsg, true);
      } else if (this.addressType == 'residential') {
        this.changeAddressService.setIsResidentialAddressUpdated(true);
        this.alertService.success(
          this.addressType[0].toUpperCase() +
          this.addressType.slice(1) +
          livoMsg,
          true
        );
      } else if (this.addressType == 'mailing') {
        this.changeAddressService.setIsMailingAddressUpdated(true);
        this.alertService.success(
           this.hasAtleastOneLegacyPolicy && !this.isAcmic ? 'Your mailing address has been updated. Changes made to your account will apply to all Mapfre Massachusetts personal active policies'
           :'Your mailing address has been updated. Changes made to your account will apply to all active policies.',
          true,'Account updated!'
        );
      }
    } else if (policyid.length == 6) {
      if (
        this.addressType == 'residential' &&
        this.changeAddressForm.value.isMailingAddress
      ) {
        this.changeAddressService.setIsResidentialAddressUpdated(true);
        this.changeAddressService.setIsMailingAddressUpdated(true);
        this.alertService.success('Residential and mailing' + as400Msg, true);
      } else if (this.addressType == 'residential') {
        this.changeAddressService.setIsResidentialAddressUpdated(true);
        this.alertService.success(
          this.addressType[0].toUpperCase() +
          this.addressType.slice(1) +
          as400Msg,
          true
        );
      } else if (this.addressType == 'mailing') {
        this.changeAddressService.setIsMailingAddressUpdated(true);
        this.alertService.success(
          this.addressType[0].toUpperCase() +
          this.addressType.slice(1) +
          as400Msg,
          true
        );
      }
    }
    if (policyid.length === 10) {
      this.customerProfileService.setModalTitle('ADDRESS');
    }
    this.router.navigate(['/my-insurance', this.policyID, 'details']);
  }

  onCheckDirty(): void {
    this.profileConfirmModalService.onCheckDirty(this.changeAddressForm);
    this.profileConfirmModalService.$checkDirty.subscribe((value) => {
      this.confirmModal = value;
    });
    if (this.confirmModal === false) {
      this.router.navigate(['/my-insurance', this.policyID, 'details']);
    }
  }

  updateButton() {

    if (!this.enableSubmitBtn) {
      this.enableSubmitBtn = true;
    }
  }

  isFormValid(value) {
    this.enableSubmitBtn = value;
  }
  hideModalAction(): void {
    this.hideModal = !this.hideModal;
  }

  resetHideModal(): void {
    this.hideModal = !this.hideModal;
  }

  ngOnInit() {
    console.log(this.policies)
    this.isAcmic = this.acmicService.isACMIC();
    this.changeAddressForm = this.ipt.toFormGroup(this.inputs);
    this.changeAddressForm.addControl(
      'isMailingAddress',
      new FormControl(true, [])
    );
    this.changeAddressForm.addControl(
      'isLocationSame',
      new FormControl('true', [])
    );
    this.confirmationModal = new ModalOptions({
      additionalClasses: 'modal-center-on-page address-confirmation-modal',
      additionalButtonClasses: 'btn mapfre basic primary update-address-btn',
      animatePosition: 'top',
      buttonCopy: 'Update Address',
      modalId: 'Confirmation Modal',
      modalTranslateCopy: 'Confirmation Modal',
      modalName: 'Confirmation Modal',
      typeOfModal: 'address confirmation ma'
    });
    this.email = JSON.parse(localStorage.getItem('currentUser')).username;
    this.activatedRoute.params.subscribe((params: Params) => {
      this.addressType = params['address-type'];
      this.policyID = params['policyid'];
    });
    this.getGooglePlaceService.$address.pipe(take(1)).subscribe((address) => {
      this.currentAddressObject = address;
      this.currentStreetAPT = this.currentAddressObject?.streetName?.split("#")[1];
      this.currentStreetName = this.currentAddressObject?.streetName?.includes('|')
        ? this.currentAddressObject.streetName.split('|')[0]
        : this.currentAddressObject?.streetName?.split('#')[0];
    })

    this.getGooglePlaceService.$address.subscribe((address) => {
      if (address) {
        console.log(address)
        if (this.state == null) {
          this.state = address.state;
        }

        address.isResidential = undefined;
        this.addressObject = address;

        if (
          this.addressObject &&
          this.isMailingAddSelected &&
          this.addressType == 'mailing'
        ) {
          this.isZipcodeValid = true;
          if (
            address.zipCode.code === 'undefined' ||
            address.zipCode.code === ''
          ) {
            this.isZipcodeValid = false;
            this.hideZipcodeField = false;
          } else {
            this.changeAddressForm.patchValue({ changeAddress_zipCode: '' });
            this.hideZipcodeField = true;
            this.hideCityStateField = true;
            this.hideMultipleCityStateField = true;
          }
        }
      }
    });

    this.getGooglePlaceService.$mailingPOBoxAddress.subscribe(
      (addressFields) => {
        console.log('addressFields', addressFields);
        if (addressFields !== undefined) {
          if (
            addressFields?.zipcode !== '' &&
            addressFields?.city !== '' &&
            addressFields?.state !== ''
          ) {
            if (addressFields?.city && addressFields?.state) {
              this.cityState = `${addressFields.city}, ${addressFields.state}`;
            }
            if (this.isMailingAddSelected) {
              this.isZipcodeValid = true;
              if (Array.isArray(addressFields.city)) {
                this.multipleCityOptionsForMailing = addressFields.city;
                this.addressObject.city = addressFields.city[0];
                this.hideCityStateField = true;
                this.hideMultipleCityStateField = false;
                this.changeAddressForm.patchValue({
                  changeAddress_state: addressFields.state,
                });
              } else {
                this.changeAddressForm.patchValue({
                  changeAddress_city_state: this.cityState,
                });
                this.addressObject.city = addressFields.city;
                this.hideMultipleCityStateField = true;
                this.hideCityStateField = false;
              }
              this.addressObject.state = addressFields.state;
              this.addressObject.zipCode.code = addressFields.zipcode;
            } else if (this.isPOBoxAddSelected) {
              this.isPoBoxZipcodeValid = true;
              if (Array.isArray(addressFields.city)) {
                this.multipleCityOptionsForPOBox = addressFields.city;
                this.poBoxCity = addressFields.city[0];
                this.hidePoBoxCityStateField = true;
                this.hidePOMultipleCityStateField = false;
                this.changeAddressForm.patchValue({
                  changeAddress_PO_state: addressFields.state,
                });
              } else {
                this.changeAddressForm.patchValue({
                  changeAddress_PO_city_state: this.cityState,
                });
                this.poBoxCity = addressFields.city;
                this.hidePOMultipleCityStateField = true;
                this.hidePoBoxCityStateField = false;
              }
              this.poBoxState = addressFields.state;
            }
          } else {
            if (this.isMailingAddSelected) {
              this.isZipcodeValid = false;
              this.hideCityStateField = true;
              this.hideMultipleCityStateField = true;
            } else if (this.isPOBoxAddSelected) {
              this.hidePoBoxCityStateField = true;
              this.isPoBoxZipcodeValid = false;
              this.hidePOMultipleCityStateField = true;
            }
          }
        }
      }
    );

    this.validateAddressService.$address.subscribe((resp) => {
      this.addressInput = resp;
    });

    this.changeAddressForm.controls.changeAddressAPT.valueChanges.subscribe(
      () => {
        this.updateButton();
      }
    );
    this.hasAtleastOneLegacyPolicy = !!this.getCompany(this.policies);
    this.isGWPolicy = !!this.getActiveGwPolicy(this.policies);

  }

  getCompany(policies) {
    return policies.find(policy => (policy.company?.companyName === 'ACIC' || policy.company?.companyName === 'TW' || policy.policynumber?.policyNumber?.length === 6));
  }

  getActiveGwPolicy(policies) {
    return policies.find(policy => (policy.policynumber?.policyNumber?.length === 10 && policy.company?.companyName === 'MA'));
  }

  closeNotification() {
    this.showNotification = false;
  }

  onCityChange(event) {
    const selectedCity = event.target.value;
    if (this.isPOBoxAddSelected) {
      this.poBoxCity = selectedCity;
    } else if (this.isMailingAddSelected) {
      this.addressObject.city = selectedCity;
    }
  }
  selectResidentialFlag(flag) {
    if (flag === 'Yes') {
      this.isLocationSame = true;
      this.changeAddressForm.get('isLocationSame').setValue(true);
    } else {
      this.isLocationSame = false;
      this.changeAddressForm.get('isLocationSame').setValue(false);
    }
  }
  selectMailingAddressType(addressType) {
    const formControls = this.changeAddressForm.controls;
    if (addressType === 'mailing-address') {
      this.isPOBoxAddSelected = false;
      this.isMailingAddSelected = true;
      formControls.changeAddress.setValidators([Validators.required]);
      formControls.changeAddress.updateValueAndValidity();
      formControls.changeAddress_poBox.clearValidators();
      formControls.changeAddress_poBox.updateValueAndValidity();
    } else if (addressType === 'poBox-address') {
      this.isPOBoxAddSelected = true;
      this.isMailingAddSelected = false;
      formControls.changeAddress_poBox.setValidators([Validators.required]);
      formControls.changeAddress_poBox.updateValueAndValidity();
      formControls.changeAddress.clearValidators();
      formControls.changeAddress.updateValueAndValidity();
    }
  }

  ngOnDestroy() {
    this.getGooglePlaceService.updateMailingPOBoxAdd(undefined);
  }
}


interface Address {
  city?: string;
  state?: string;
  streetName?: string;
  zipCode?: { code?: string; }
  isResidential?: boolean;
  policyid?: string;
}